import addEditContractDialog from './dialog-reducers/add-edit-contract-dialog-reducer';
import addProductToContractDialog from './dialog-reducers/add-product-to-contract-dialog';
import publishDraftDialog from './dialog-reducers/publish-draft-dialog-reducer';
import freeContractDialog from './dialog-reducers/free-contract-for-contractor-dialog';
import resendContractDialog from './dialog-reducers/resend-contract-reducer';
import requestsWithSameNameOrDomainDialog from './dialog-reducers/requests-with-same-name-or-domain-reducer';
import requestDL from './dialog-reducers/request-data-loading';

export default {
  addEditContractDialog,
  addProductToContractDialog,
  publishDraftDialog,
  freeContractDialog,
  resendContractDialog,
  requestsWithSameNameOrDomainDialog,
  requestDL,
};



// WEBPACK FOOTER //
// ./src/app/stores/contracting/dialogs/dialog-reducers.js